import React from 'react';
import { styled } from '@ff/ui';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import FFLogo from '../FFLogo';

const Overlay = styled.Box(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '386px',
  height: '100%',
  width: '100%',
  [theme.mediaQueries.md]: {
    height: 'calc(100vh - 280px)',
  }
}));

const FullScreenOverlay = styled(Overlay)(({ theme }) => ({
  backgroundColor: theme.colors.white,
  position: 'fixed',
  width: '100%',
  height: '100vh',
  overflow: 'hidden',
  left: '0',
  top: '0',
}));

const Container = styled.Box(({ theme }) => ({
  display: 'inline-block',
  verticalAlign: 'middle',
  position: 'relative',
  textAlign: 'center',
  color: theme.colors.coolGrey,
  border: '10px solid transparent',

  '&::before': {
    content: "''",
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'middle',
  }
}));

const Progress = styled(CircularProgress)({
  position: 'absolute',
  top: '0',
  left: '0',
});

const LogoContainer = styled.Box({
  position: 'absolute',
  top: '25px',
  left: '15px'
});

export default function Loader(props) {
  const {
    width,
    height,
    progressValue,
    isFullScreen
  } = props;

  const OverlayWrapper = isFullScreen ? FullScreenOverlay : Overlay;

    return (
      <OverlayWrapper width={width} height={height}>
        <Container width={120} height={120}>
          <Progress
            size={100}
            color="inherit"
            variant={progressValue ? 'determinate' : 'indeterminate'}
            value={progressValue || 0}
          />
          <LogoContainer>
            <FFLogo size="50px" clickable={false} />
          </LogoContainer>
        </Container>
      </OverlayWrapper>
    );
}

Loader.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  progressValue: PropTypes.number,
  isFullScreen: PropTypes.bool
};

Loader.defaultProps = {
  width: undefined,
  height: undefined,
  progressValue: undefined,
  isFullScreen: false
};
